import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';

import { CBMError, Contract, Shapes } from 'app/models';
import { ContractType } from 'app/models/enums';
import { ContractService, ShapefileService } from 'app/services';

interface CBMFileInput {
  field: string;
  accept: string;
  language: string;
}

@Component({
  selector: 'app-import-shapes',
  templateUrl: './import-shapes.component.html',
  styleUrls: ['./import-shapes.component.scss']
})
export class ImportShapesComponent implements OnInit {
  @ViewChildren('theRwsFileInputs') allRwsFileInputs: QueryList<ElementRef>;
  @ViewChildren('theFcdFileInputs') allFcdFileInputs: QueryList<ElementRef>;

  public contracts: Contract[];
  public selectedContractId: string;
  public isImportingShapes = false;
  public errorMessages: CBMError[] = [];

  public rwsFileInputs: CBMFileInput[] = [
    { field: 'file_pointShp', accept: '.shp', language: 'SHAPES.POINT_SHP' },
    { field: 'file_pointShx', accept: '.shx', language: 'SHAPES.POINT_SHX' },
    { field: 'file_pointPrj', accept: '.prj', language: 'SHAPES.POINT_PRJ' },
    { field: 'file_pointDbf', accept: '.dbf', language: 'SHAPES.POINT_DBF' },
    { field: 'file_lineShp', accept: '.shp', language: 'SHAPES.LINE_SHP' },
    { field: 'file_lineShx', accept: '.shx', language: 'SHAPES.LINE_SHX' },
    { field: 'file_linePrj', accept: '.prj', language: 'SHAPES.LINE_PRJ' },
    { field: 'file_lineDbf', accept: '.dbf', language: 'SHAPES.LINE_DBF' }
  ];

  public fcdFileInputs: CBMFileInput[] = [
    { field: 'file_lineShp', accept: '.shp', language: 'IMPORT.FCDSHP' },
    { field: 'file_lineShx', accept: '.shx', language: 'IMPORT.FCDSHX' },
    { field: 'file_linePrj', accept: '.prj', language: 'IMPORT.FCDPRJ' },
    { field: 'file_lineDbf', accept: '.dbf', language: 'IMPORT.FCDDBF' }
  ];

  constructor(private readonly contractService: ContractService, private readonly shapefileService: ShapefileService) {}

  ngOnInit() {
    this.contractService.getContracts().subscribe(
      contracts => {
        this.contracts = contracts ? contracts.filter(c => c.contractType === ContractType.FCD) : [];
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  public importRwsShapes() {
    this.isImportingShapes = true;
    this.errorMessages = [];

    const shapes: Shapes = this.parseRwsShapesInput();

    this.shapefileService.importRwsShapefile(shapes).subscribe(
      result => {
        this.isImportingShapes = false;
      },
      (errors: CBMError[]) => {
        this.isImportingShapes = false;
        this.errorMessages = errors;
      }
    );
  }

  public importFcdShapes() {
    this.isImportingShapes = true;
    this.errorMessages = [];

    const shapes: Shapes = this.parseFcdShapesInput();

    this.shapefileService.importFcdShapefile(this.selectedContractId, shapes).subscribe(
      result => {
        this.isImportingShapes = false;
      },
      (errors: CBMError[]) => {
        this.isImportingShapes = false;
        this.errorMessages = errors;
      }
    );
  }

  private parseRwsShapesInput(): Shapes {
    const shapes = new Shapes();

    this.allRwsFileInputs.forEach((fileInput: ElementRef) => {
      const inputEl: HTMLInputElement = fileInput.nativeElement;
      if (inputEl.files.length > 0) {
        const fileInputInfo: CBMFileInput = this.findCBMFileRwsInputForElementByField(inputEl.id);
        shapes[fileInputInfo.field] = inputEl.files.item(0);
      }
    });
    return shapes;
  }

  private findCBMFileRwsInputForElementByField(field: string): CBMFileInput {
    for (const fi of this.rwsFileInputs) {
      if (fi.field === field) {
        return fi;
      }
    }
    return null;
  }

  private parseFcdShapesInput(): Shapes {
    const shapes = new Shapes();

    this.allFcdFileInputs.forEach((fileInput: ElementRef) => {
      const inputEl: HTMLInputElement = fileInput.nativeElement;
      if (inputEl.files.length > 0) {
        const fileInputInfo: CBMFileInput = this.findCBMFileFcdInputForElementByField(inputEl.id);
        shapes[fileInputInfo.field] = inputEl.files.item(0);
      }
    });
    return shapes;
  }

  private findCBMFileFcdInputForElementByField(field: string): CBMFileInput {
    for (const fi of this.fcdFileInputs) {
      if (fi.field === field) {
        return fi;
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/import/shapes/import-shapes.component.ts